<script setup lang="ts">
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const videoScrollScrubber = ref<HTMLElement | null>(null);
gsap.registerPlugin(ScrollTrigger);
const videoPlayer = ref<HTMLVideoElement | null>(null);

onMounted(() => {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: videoScrollScrubber.value,
      start: 'top top',
      end: '+=250%',
      scrub: 1,
      // markers: true,
      pin: true,
    },
  });

  tl.to(videoPlayer.value, {currentTime: videoPlayer.value.duration, ease: 'none'});

  // if (isTouchDevice()) {
  //   videoPlayer.value.play();
  //   videoPlayer.value.pause();
  // }
});

// function isTouchDevice() {
//   return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
// }
</script>

<template>
  <div ref="videoScrollScrubber" class="video-scroll-scrubber">
    <video ref="videoPlayer" :src="`${useCdnUrl()}/assets/video/animated-building.mp4`" muted preload="auto" class="video-background" :poster="`${useCdnUrl()}/assets/video/animated-building-poster.webp`"></video>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/scss/queries';
.video-scroll-scrubber {
  height: 100vh;
  width: 100%;
  overflow: hidden;

  video {
    width: 100%;
    height: auto;
    min-height: 100vh;
    object-fit: cover;
  }
}
</style>
